import {
  getZonasPanel,
  deleteZona,
} from "../../../../services/ZonasServices";

export const getDataGrid = async (searchTerm, page, perPage, suc_id) => {
  return await getZonasPanel(searchTerm, page, perPage, suc_id);
};

export const deleteDataGrid = async (id) => {
  return await deleteZona(id);
};

// Función para cargar datos con paginación
export const fetchEntityData = async (
  getData,
  searchTerm,
  numPagina,
  filas
) => {
  try {
    const result = await getData(searchTerm, numPagina, filas);
    return {
      dataEntity: result?.zonas || [],
      totalItems: result?.pagination?.totalItems || 0,
      totalPage: result?.pagination?.totalPage || 1,
      totalDataItems: result?.pagination?.totalItems || 0,
    };
  } catch (error) {
    console.error("Error fetching data:", error);
    return {
      dataEntity: [],
      totalItems: 0,
      totalPage: 1,
      totalDataItems: 0,
    };
  }
};

// Función para eliminar item
export const deleteItem = async (deleteData, id) => {
  try {
    await deleteData(id);
    return true;
  } catch (error) {
    console.error("Error deleting item:", error);
    throw error;
  }
};
